import { UserData } from 'components/Sidebar/Sidebar_Principal';
import Cargando from 'components/Varios/Cargando';
import React, { useEffect, useState } from 'react'

//BOOTSTRAP
import { Row, Col, Container, Card, CardHeader, CardBody } from "reactstrap";
import { authenticationService } from 'services/authentication.service';
import { ObtenerContratosBecas } from './functionsContratosBecas';
import { InformacionContratoBecas, StatesContratoBecas } from './TypesContratoBecas';

//ESTILOS
import CardInfoContratosBecas from './CardInfoContratosBecas';


const ContratosBecas = () => {

    const [stateContratosBecas, setstateContratosBecas] = useState<StatesContratoBecas>({
        listaContatosBecas: [],
        loadingContratosBecas: false
    });

    async function GetInformacion(infoUsuario: UserData) {
        setstateContratosBecas({ ...stateContratosBecas, loadingContratosBecas: true });
        const resultado: InformacionContratoBecas[] = await ObtenerContratosBecas(infoUsuario);
        setstateContratosBecas({ ...stateContratosBecas, loadingContratosBecas: false, listaContatosBecas: resultado });

    }

    const GetCardsContratosBecas = (listadoConvenios: Array<InformacionContratoBecas>) => {
      
        var CardsContratosBecas= listadoConvenios.map((valores, indiceValores) => {
            return (
                <Col sm={12} md={6} xl={4} key={"CardContratosBecas" + indiceValores + 1} className="mb-5">
                    <CardInfoContratosBecas datosCards={valores} indice={indiceValores + 1} total={listadoConvenios.length} />
                </Col>
            )
        })
        return CardsContratosBecas;
    }
   

    const NoContratosBecasComponent = () => {
        return (
            <div>No registra contratos de beca</div>
        )
    }

    useEffect(() => {
        var userInfo: UserData = authenticationService.currentUserValue;
        GetInformacion(userInfo);
    }, [])



    if (stateContratosBecas.loadingContratosBecas) {
        return <Cargando mensaje='Cargando Contratos Becas' />
    }


    return (
        <div className="content">

            <Row className="row-no-margin">
                <Col xl={12} >
                    <Card className="principal">
                        <CardHeader>
                            <h5 className="title">CONTRATOS DE BECA</h5>
                            <CardBody className="main-content">
                                <div id="container_cardbody_convenios">
                                   
                                            <Row >
                                                {stateContratosBecas.listaContatosBecas.length !== 0 &&
                                                    GetCardsContratosBecas(stateContratosBecas.listaContatosBecas)
                                                }
                                                {
                                                    stateContratosBecas.listaContatosBecas.length === 0 &&
                                                    NoContratosBecasComponent()
                                                }
                                            </Row>
                                       

                                </div>
                            </CardBody>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>

        </div>

    )
}

export default ContratosBecas;